const Validation = (type, param, param2, lang) => {
    //console.log("Validation", param, param2, type, /[\'\"\-.?0-9A-z\İ\Ğ\Ş\Ö\Ç\Ü\ı\ğ\ü\ş\ç\ö \$\€\%\+\#\₺\£\!]/g.test(param));
    switch(type){
        case "general":
            if (param === "") return (lang=="tr")?"Bu Alanı Boş Bırakmayınız":"Do not leave this field blank";
            else if (!!String(param).match(/[^\'\"\-.?0-9A-z\İ\Ğ\Ş\Ö\Ç\Ü\ı\ğ\ü\ş\ç\ö \$\€\%\+\#\₺\£\!]/g)) return (lang==="tr")?"Bu Alan Yalnızca Harflerden Oluşmalıdır":"This Field Must Only Be Letters";
            else return "";
        case "empty":
            if (param === "") return (lang=="tr")?"Bu Alanı Boş Bırakmayınız":"Do not leave this field blank";
            else return "";
        case "text":
            if (param === "") return (lang=="tr")?"Bu Alanı Boş Bırakmayınız":"Do not leave this field blank";
            else if (String(param).length < 2) return (lang==="tr")?"Bu Alan En Az 2 Karakterden Oluşmalıdır":"This field must contain at least 2 characters";
            else if (!!String(param).match(/[^ A-z\İ\Ğ\Ş\Ö\Ç\Ü\ı\ğ\ü\ş\ç\ö]/g)) return (lang==="tr")?"Bu Alan Yalnızca Harflerden Oluşmalıdır":"This Field Must Only Be Letters";
            else return "";
        case "number":
            if (param === "") return (lang==="tr")?"Bu Alanı Boş Bırakmayınız":"Do not leave this field blank";
            else if (!!String(param).match(/[^0-9]/g)) return (lang==="tr")?"Bu Alan Yalnızca Rakamlardan Oluşmalıdır":"This Field Must Only consist of Numbers";
            else return "";
        case "email":
            if (param === "") return (lang==="tr")?"Bu Alanı Boş Bırakmayınız":"Do not leave this field blank";
            else if (param.length < 5) return (lang==="tr")?"Bu Alan En Az 5 Karakterden Oluşmalıdır":"This field must contain at least 5 characters";
            else if (String(param).match(/[.\@]/) == null) return (lang==="tr")?"E-Posta '@' ve '.' İçermelidir":"E-Mail '@' and '.' It should contain";
            else return "";
        case "pass":
            if (param === "") return "Şifre Boş Bırakmayınız";
            else if (String(param).length < 8) return "Şifre En Az 8 Karakterden Oluşmalıdır";
            else if (!!String(param).match(/[A-Z\İ\Ğ\Ş\Ö\Ç\Ü]/g) === false) return "Şifre En Az Bir Büyük Harf İçermelidir";
            else if (!!String(param).match(/[a-z\ı\ğ\ü\ş\ç\ö]/g) === false) return "Şifre En Az Bir Küçük Harf İçermelidir";
            else if (!!String(param).match(/[0-9]/g) === false) return "Şifre En Az Bir Rakam İçermelidir";
            else if (!!String(param).match(/[!\'\^\+\%\&\*\"\.\,\?\-\_\:\;]/g) === false) return "Şifre En Az Bir Özel Karakter İçermelidir";
            else return "";
        case "phone":
            if (param === "") return (lang==="tr")?"Bu Alanı Boş Bırakmayınız":"Do not leave this field blank";
            else if (param.length < 10) return "Telefon En Az 10 Karakterden Oluşmalıdır";
            else if (!!String(param).match(/[^0-9]/g)) return "Telefon Sadece Rakamlardan Oluşmalıdır";
            else return "";
        case "price":
            if (!!String(param).match(/[^0-9.]/g)) return "Sadece Rakam ve '.' girebilirsiniz";
            else return "";
        case "passConfirm":
            if (param !== param2) return "Şifreler Uyuşmuyor";
            else return "";
        default:
            return "Validate edilecek element tipi belirtilmelidir";
    }

};

export default Validation;